import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LOCATION_TOKEN } from '@mri-platform/shared/core';

@Pipe({ standalone: true, name: 'prefixUrlProtocol' })
export class PrefixUrlProtocolPipe implements PipeTransform {
  constructor(@Inject(LOCATION_TOKEN) private readonly location: Location) {}
  transform(url: string): string {
    const protocolPrefix = /^https?:\/\//g.test(url) ? '' : this.location.protocol + '//';
    return protocolPrefix + url;
  }
}
